<template>
    <div id="contenedor-album-frentes">
        <template v-if="!getAlbum.length < 1">
          <template v-if="!$vuetify.breakpoint.mobile">
            <desktop
            :album="getAlbum"
            :modulo="modulo"
            :numeroContrato="getNumeroContrato">
            </desktop>
          </template>

          <template v-else>
            <mobile
            :album="getAlbum"
            :modulo="modulo"
            :numeroContrato="getNumeroContrato">

            </mobile>
          </template>
        </template>
        <template v-else>
          <v-card flat>
            <v-card-text>
              <v-row justify="center" align="center">
                <v-alert class="mt-4" type="info">
                  El contrato no cuenta con fotos registradas.
                </v-alert>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
    </div>
</template>
<script>
import Desktop from '@/components/administracion/albumfrentes/listado/Desktop.vue';
import Mobile from '@/components/administracion/albumfrentes/listado/Mobile.vue';
import mixAlbumFrentes from './mixAlbumFrentes';

export default {
  name: 'albumFrentes',
  props: {
    idContrato: {
      type: String,
      required: true,
    },
    modulo: {
      type: String,
      required: true,
    },

  },
  mixins: [mixAlbumFrentes],
  components: {
    Desktop,
    Mobile,
  },

};
</script>
